import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowUpWall"><Path d="M20 21H4V19.5H20V21Z" fill="currentColor"/><Path d="M17.5605 8.25L16.5 9.31055L12.75 5.56055V17H11.25V5.56055L7.5 9.31055L6.43945 8.25L12 2.68945L17.5605 8.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpWall;
